import { getTheme, IStyle, mergeStyleSets } from '@fluentui/react'

export const internal__useBwjScrollContainerStyles = () => {
  
  const theme = getTheme();

  const defaultContainerStyle: IStyle = { 
    overflow: 'auto',
    position: 'relative',
    height: '100%'
  };

  const scrollButton: IStyle = {
    backgroundColor: theme.palette.themePrimary,
    color: theme.palette.white,
    border: 'none',
    borderRadius: '50%',
    padding: 10,
    cursor: 'pointer',
    fontSize: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0.6px 0.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
    transition: 'all 300ms linear',
  };

  const buttonPositioner: IStyle = {
    position: 'sticky',
    top: '100%',
    left: '100%',
    width: 0,
    height: 0,
    zIndex: 10,
  };

  const buttonContainer: IStyle = {
    position: 'absolute',
    bottom: 24,
    right: 24,
  };

  return mergeStyleSets({
    defaultContainerStyle,
    scrollButton,
    buttonPositioner,
    buttonContainer,
  });
}